import { call, put, takeLatest } from "redux-saga/effects"

import axios from "axios"
import { push } from "connected-react-router"
import {
  exportDivisionSegment,
  importDivisionErrorSegment,
} from "../../utils/segment/Division/divisionTrack"

import {
  GET_TEMPLATE_DIVISION_WATCHER,
  UPLOAD_TEMPLATE_WATCHER,
} from "./constants"

import {
  getTemplateSuccess,
  getTemplateFailed,
  uploadTemplateSuccess,
  uploadTemplateFailed,
} from "./actions"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// GET EXCEL
function getDivisionTemplateApi(isTemplate) {
  woopraTrack("Descargar plantilla Divisiones")
  const asdf = isTemplate ? "/template" : ""
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/export/xlsx${asdf}`,
  })
}

function getDivisionTemplateApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/export/xlsx/progress`,
  })
}

function donwloadDivisionTemplate(url) {
  location.replace(url)
}

export function* getDivisionTemplateSaga(action) {
  try {
    yield call(messageProgress, "Descargando plantilla")

    yield call(getDivisionTemplateApi, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getDivisionTemplateApiProgress)

      if (data.status === 200) {
        break
      }
    }

    yield call(donwloadDivisionTemplate, data.data[0].url)
    yield call(messageDestroy)
    yield call(messageSuccess, getStatusExport("Plantilla descargada"))
    yield put(getTemplateSuccess())
  } catch (e) {
    yield call(messageDestroy)
    yield call(
      messageFailed,
      getStatusExport("Error al descargar la plantilla")
    )
    yield put(getTemplateFailed())
  }
}

function getStatusExport(status) {
  exportDivisionSegment(status, "exportTemplate", "")
  return status
}

// UPLOAD TEMPLATE
function uploadTemplate(payload) {
  woopraTrack("Importar archivo Divisones")
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

function uploadTemplateSummary() {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx/summary`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
}

export function* uploadTemplateSaga(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    yield call(uploadTemplate, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateProgress)

      if (data.status === 200) {
        break
      }
    }
    const otherData = yield call(uploadTemplateSummary)
    yield put(uploadTemplateSuccess(otherData.data[0]))
    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(push("/organization/divisions/summary"))
  } catch (e) {
    yield call(messageDestroy)
    yield call(
      messageFailed,
      getStatusFailedImport("Error al importar el archivo")
    )
    yield put(uploadTemplateFailed())
    yield put(push("/organization#divisions"))
  }
}

function getStatusFailedImport(status) {
  importDivisionErrorSegment(status)
  return status
}

export default function* getDivisionWatcherSaga() {
  yield takeLatest(GET_TEMPLATE_DIVISION_WATCHER, getDivisionTemplateSaga)
  yield takeLatest(UPLOAD_TEMPLATE_WATCHER, uploadTemplateSaga)
}
